var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deviceList"},[_c('div',{staticClass:"nav clearfix"},[_c('row',[_c('van-col',{attrs:{"span":"2"}},[_c('Icon',{attrs:{"name":"arrow-left","size":"26"}})],1),_c('van-col',{staticStyle:{"font-size":"19px"},attrs:{"span":"18","align":"center","justify":"center"}},[_vm._v("派工调度")])],1)],1),_c('bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }